import { useQuery } from '@tanstack/react-query'

import { getOperatorWithdrawalTransactions } from '../../services'
import { BankQueryKeys } from '../../../keys'

import type { GetOperatorWithdrawalTransactionsRequest } from '../../../type'

export default function useQueryOperatorWithdrawalTransactions(
	payload: GetOperatorWithdrawalTransactionsRequest,
) {
	return useQuery({
		queryKey: [BankQueryKeys.OperatorWithdrawalTransactions, payload],
		queryFn: () => getOperatorWithdrawalTransactions(payload),
	})
}
